import React from 'react';

import Icons from './Icons';

const StepProject = () => {
  return (
    <div className="bg">
      <div className="container">
        <div className="step bg second">
          <div className="left-section">
            <div className="number-border">
              <div className="number-step">
                <span>2</span>
              </div>
            </div>
          </div>
          <div className="right-section">
            <h3 className="tt">Project kick-off</h3>
            <div className="content b-bottom">
              <div className="row">
                <div className="col-md-6">
                  <p>
                    Let&apos;s plan our journey - we always have things sorted
                    out. We understand your needs and make sure you know how we
                    work. For a kick-off, we align and deploy the team, tools
                    and set Scrum artifacts and meetings. This way we ensure we
                    always run with maximum efficiency!
                  </p>
                </div>
              </div>
            </div>
            <Icons
              yourRoleDetails="Take an active role in the process and work planning, be ready to give feedback and make decisions"
              outcomeDetails="The team knows the process and roles, communication methods and milestones"
              ourRoleDetails="Propose communication pattern, implement and onboard on tools and processes"
              durationDetails="1-2 weeks"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepProject;
